import { gql } from '@apollo/client'

export const GET_QA_ORDERS = gql`
  query GetQAOrders($projectId: Int!) {
    orders(projectId: $projectId) {
      count
      data {
        id
        title
        code
        jsonSchema
        totalTasksCount
        dataLayer {
          wmsFeatureTypeName
          boundaries
        }
        paLayer {
          wmsFeatureTypeName
          boundaries
        }
      }
    }
  }
`

export const GET_QA_RECORD = gql`
  query GetQARecord($orderId: Int!, $pk: Int) {
    qaRecords(orderId: $orderId, pageInfo: { limit: 1 }, pk: $pk) {
      count
      data {
        id
        data
        mapData
        geometry
        sourceProperties
      }
    }
  }
`

export const SEARCH_QA_RECORDS = gql`
  query SearchQARecords(
    $orderId: Int!
    $filters: [DjangoFilterInput!]
    $pageInfo: PageInfo
  ) {
    qaRecords(orderId: $orderId, filters: $filters, pageInfo: $pageInfo) {
      data {
        id
        data
        geometry
        mapData
        sourceProperties
      }
    }
  }
`
